module.exports = __webpack_public_path__ + "static/media/twitter.a214b650.svg";